import { render, staticRenderFns } from "./printOrdersList.vue?vue&type=template&id=ad2dea58&scoped=true&"
import script from "./printOrdersList.vue?vue&type=script&lang=js&"
export * from "./printOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./printOrdersList.vue?vue&type=style&index=0&id=ad2dea58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2dea58",
  null
  
)

export default component.exports